module.exports = __webpack_public_path__ + "img/temperature-lg.3cf79351.svg";